/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import e from "react";
import { Button as a } from "@progress/kendo-react-buttons";
import { chevronUpIcon as p, chevronDownIcon as m } from "@progress/kendo-svg-icons";
const i = (o) => {
  const [t, r] = e.useState(!0), { children: c, title: n } = o;
  return /* @__PURE__ */ e.createElement("div", { className: "k-prompt-expander" }, /* @__PURE__ */ e.createElement(
    a,
    {
      fillMode: "flat",
      svgIcon: t ? p : m,
      title: n,
      onClick: () => r(!t)
    },
    n
  ), t && /* @__PURE__ */ e.createElement("div", { className: "k-prompt-expander-content" }, c));
};
export {
  i as AIPromptExpander
};
